// Pass an approved image source when available. No placeholder or empty space
// is rendered until the client's portrait has been supplied.
export default function PersonPortrait({ src, name, compact = false }) {
  if (!src) return null;
  return <img src={src} alt={name} loading="lazy" width="400" height="400" className={`sn-mb-5 sn-aspect-square sn-h-auto sn-w-full sn-rounded-card sn-object-cover ${compact ? "sn-max-w-24" : "sn-max-w-48"}`} />;
}
